// extracted by mini-css-extract-plugin
export var actionButton = "_j8-0";
export var fileInput = "_j8-2";
export var paperclip = "_j8-1";